import React from 'react';

import { createReactRenderer } from '../helpers/react-renderer';
import {
  SENSITIVE_INFO_WARNING_REMOVE_LINK,
  SENSITIVE_INFO_WARNING_REMOVE_LINK_CUSTOMER_PAGE,
} from 'root/merchantos/utils';

let modalLinkCount = 0;
interface RemoveLinkProps {
  container: HTMLElement;
  showAddSavedCardLink: boolean;
}

const RemoveLink = ({ container, showAddSavedCardLink }: RemoveLinkProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();

    // Find all input fields with the error classes
    const errorFields = container.querySelectorAll(
      'input.credit-card-info-error.error, textarea.credit-card-info-error.error'
    );

    // Clear each error field
    errorFields.forEach((field: Element) => {
      const inputField = field as HTMLInputElement | HTMLTextAreaElement;

      // Clear the input value
      inputField.value = '';

      // Remove the error classes
      inputField.classList.remove('credit-card-info-error', 'error');

      // Trigger any validation events to update the UI
      inputField.dispatchEvent(new Event('input', { bubbles: true }));
      inputField.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Hide the error message container
    const errorMessageContainer = container.parentElement?.querySelector('.sensitive-info-error');
    if (errorMessageContainer) {
      errorMessageContainer.classList.remove('visible');
    }

    // Clear the error tracker
    const errorTracker = container.parentElement?.querySelector('.error-tracker');
    if (errorTracker) {
      errorTracker.innerHTML = '';
    }
  };

  return (
    <a href="#" onClick={handleClick}>
      {showAddSavedCardLink
        ? SENSITIVE_INFO_WARNING_REMOVE_LINK_CUSTOMER_PAGE
        : SENSITIVE_INFO_WARNING_REMOVE_LINK}
    </a>
  );
};

// Function to render the RemoveLink into a DOM element
// This can be used from non-React contexts like utils.ts
export const renderRemoveLink = (
  container: HTMLElement,
  options: {
    container: HTMLElement;
    showAddSavedCardLink: boolean;
  }
) => {
  modalLinkCount += 1;
  const uniqueId = `remove-link-${modalLinkCount}`;
  container.id = uniqueId;

  const RenderedComponent = createReactRenderer({
    component: RemoveLink,
    selector: `#${uniqueId}`,
  });
  RenderedComponent.mount({ props: { ...options } });
  return RenderedComponent;
};

export default RemoveLink;
